/**
 * handleDateFormSubmit
 * @param element
 */
window.handleDateFormSubmit = function(element) {
    const form = element.closest('form');
    const dateFrom = form.querySelector('#date-from');
    const dateTo = form.querySelector('#date-to');

    let hasError = false;

    [dateFrom, dateTo].forEach(input => {
        const field = input.closest('.form-field');
        if (!input.value) {
            field.classList.add('form-field--error');
            hasError = true;
        } else {
            field.classList.remove('form-field--error');
        }
    });

    if (dateFrom.value && dateTo.value && dateFrom.value > dateTo.value) {
        dateTo.closest('.form-field').classList.add('form-field--error');
        hasError = true;
    }

    if (hasError) return;

    element.textContent = LANG_STRINGS.BITTE_WARTEN;
    element.disabled = true;
    form.submit();
}

window.befaehigungsausweis__submit = handleDateFormSubmit;
window.weiterbildungsstunden__submit = handleDateFormSubmit;
window.beratungsstunden__submit = handleDateFormSubmit;

/**
 * weiterbildungsstunden_Index
 */
window.weiterbildungsstunden_Index = function() {
    $('input.select-ausdruck').on('click', function() {
        if ($('input.select-ausdruck:checked').length > 0) {
            $('#weiterbildungsstunden-uploadBetriebsmappe-js').removeAttr('disabled');
        } else {
            $('#weiterbildungsstunden-uploadBetriebsmappe-js').attr('disabled', true);
        }
    });
};

/**
 * weiterbildungsstunden__uploadBetriebsmappe
 * @param id
 * @param request_uri
 */
window.weiterbildungsstunden__uploadBetriebsmappe = function(id, request_uri) {
    var selected = [];
    $('input.select-ausdruck:checked').each(function() {
        selected.push($(this).val());
    });

    ajaxDialog(BASE_PATH + '/ajax/dialog/uploadBetriebsmappe?teilnehmerID=' + id + '&selectedAusdrucke=' + encodeURIComponent(JSON.stringify(selected)), 742, {
        post_data: {
            request_uri: request_uri,
        },
    });
};

/**
 * uploadBetriebsmappe_Index
 */
window.uploadBetriebsmappe_Index = function() {
    $('#save').on('click', function() {
        if ($(this).prop('checked')) {
            $('#submit-button').prop('disabled', false);
        } else {
            $('#submit-button').prop('disabled', true);
        }
    });
};
